module.exports = __webpack_public_path__ + "static/media/template.d4e85a04.csv";